module.exports = __webpack_public_path__ + "static/3-ce24cf53ac5ca031bbceb442b7e2554f.jpg";